// src/models/Project/Project.ts
import axiosAPI from '../../utils/client/axiosAPI';
import { ProjectPayload, ProjectResponse } from './contracts';

export class Project {
  public readonly id: number;
  public readonly name: string;
  public readonly points_required: number;
  public readonly price: number;
  public readonly duration: number;

  constructor(data: ProjectResponse) {
    this.id = data.id;
    this.name = data.name;
    this.points_required = data.points_required;
    this.price = data.price;
    this.duration = data.duration;
  }

  // Fetch all projects as array
  static async all(): Promise<Project[]> {
    const { data } = await axiosAPI.get<ProjectResponse[]>('/projects');
    return data.map((project) => new Project(project));
  }

  // Fetch a single project by ID
  static async get(id: number | string): Promise<Project> {
    const { data } = await axiosAPI.get<ProjectResponse>(`/projects/${id}`);
    return new Project(data);
  }

  // Create a new project
  static async store(payload: ProjectPayload): Promise<Project> {
    const { data } = await axiosAPI.post<ProjectResponse>(
      'admin/projects',
      payload
    );
    return new Project(data);
  }

  // Update existing project
  async update(payload: ProjectPayload): Promise<Project> {
    const { data } = await axiosAPI.put<ProjectResponse>(
      `admin/projects/${this.id}`,
      payload
    );
    return new Project(data);
  }

  // Delete a project
  static async delete(id: number) {
    return await axiosAPI.delete<null>(`admin/projects/${id}`);
  }
}
